import React from "react";
import { matchPath, useHistory, useLocation } from "react-router-dom";
import { useAuthentication } from "../context/authentication";
import { useContacts } from "../context/contacts";
import { DottedMenu } from "../context/dropdownMenu/DropdownMenuProvider";
import { useToast } from "../context/toast";
import { Contact } from "../utils/types";

interface Props {
  disabled?: boolean;
  contact: Contact;
  toggleEditContactForm: (contact: Contact) => void;
}

const ContactActionsButton: React.FC<Props> = ({
  disabled,
  contact,
  toggleEditContactForm
}) => {
  const { setModalWarningConfig } = useToast();
  const { wrapActionWithAuth } = useAuthentication();
  const { removeContact } = useContacts();
  const browserLocation = useLocation();
  const history = useHistory();

  const detailsPageMatch = matchPath<{
    id: string;
    section: string;
  }>(browserLocation.pathname, {
    path: "/contacts/:id/:section"
  });

  return (
    <DottedMenu
      disabled={disabled}
      text="Open contact actions"
      className="z-10"
      menuItems={[
        {
          text: "Edit contact",
          onClick: wrapActionWithAuth(() => {
            toggleEditContactForm(contact);
          })
        },
        {
          text: "Remove contact",
          onClick: wrapActionWithAuth(() => {
            setModalWarningConfig({
              open: true,
              resolve: () => {
                removeContact(contact.uuid);

                if (detailsPageMatch?.params?.id === contact.uuid) {
                  history.push("/contacts");
                }
              }
            });
          })
        }
      ]}
    />
  );
};

export default ContactActionsButton;
